import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../../redux/hooks'
import { getCTXRlist, getCTXRlistGlobal } from '../request/request'
import axios from 'axios'
import Spinner from '../../../custom/Spinner/Spinner'
import './estilos.css'
import '../../../../styles/components/customSelects.css'
import { useAuth } from '../../../auth'
import styles from '../../statusGral/cloudStatusTable.module.scss' // Reutilizando el mismo estilo (por ejemplo, LicenseCrud)

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'

const API_URL = process.env.REACT_APP_API_URL

type BGP = {
  // Core BGP routing information
  nlri: string                    // Network Layer Reachability Information (prefix)
  family: string                  // Address family (e.g., "unicast")
  localpreference: string         // Local preference value for route selection
  extendedcommunity: string | null // Extended community attributes
  neighbor: string                // BGP neighbor IP address
  community: string | null        // BGP community attributes
  type: string                    // Direction: 'in' | 'out' | 'all'

  // CTX-R specific information
  ctxrId: string                  // CTX-R unique identifier
  ctxrName: string                // CTX-R display name

  // BGP session details
  localip: string                 // Local BGP interface IP
  localas: string                 // Local Autonomous System number
  peeras: string                  // Peer Autonomous System number
  routerid: string                // BGP router identifier

  // Route attributes
  familyallowed: string           // Allowed address families for this session
  rd: string | null               // Route distinguisher (for VPN routes)
  origin: string                  // Route origin (IGP, EGP, incomplete)
  aspath: string | null           // AS path attribute
  label: string | null            // MPLS label information
  nexthop: string                 // Next hop IP address
  subnet: string | null           // Subnet information
  route_table: string             // Associated route table IDs (semicolon-separated)
}

type nei = {
  neighbor: string
}

export default function BGPCTXR(props: any) {
  const Id = useAppSelector((state) => state.SuscriptionSlice.id)
  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const tenant = useAppSelector((state) => state.TenantSlice.id)
  const nameregion = useAppSelector((state) => state.RegionSlice.name)

  const { currentUser } = useAuth()

  // Lista de CTX-R
  const [CTXR, setctxr] = useState<
    Array<{ id: number; name: string; type: string; description?: string }>
  >([{ id: 0, name: ' ', type: '' }])

  // ID (ctxr) seleccionado
  const [Busqueda, setBusqueda] = useState('')

  // Lista de neighbors
  const [listneighbor, setlistneig] = useState<nei[]>([])

  // Estados para BGP data
  const [DataBGP, setDataBGP] = useState<BGP[]>([])

  // Loading spinner
  const [loading, setLoading] = useState(false)

  // Campos del formulario (Neighbor, Direction)
  const [neighselect, setneighselect] = useState<string | undefined>('')
  const [direction, setdirection] = useState('')

  // Manejo de filas expandidas
  const [expandedRows, setExpandedRows] = useState<number[]>([])

  // Paginación
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  // Búsqueda / Filtros
  const [searchTerm, setSearchTerm] = useState('')
  const [searchColumn, setSearchColumn] = useState('All')

  // Ordenación
  const [sortColumn, setSortColumn] = useState<string>('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

  // ------------------------------------------------------------------------------
  // Ordenación
  // ------------------------------------------------------------------------------
  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc' ? (
        <KeyboardArrowUpIcon className={styles['sort-icon']} />
      ) : (
        <KeyboardArrowDownIcon className={styles['sort-icon']} />
      )
    } else {
      return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />
    }
  }

  function applySort(data: BGP[]) {
    if (!sortColumn) return data
    const sorted = [...data].sort((a, b) => {
      const valA = a[sortColumn as keyof BGP]?.toString().toLowerCase() || ''
      const valB = b[sortColumn as keyof BGP]?.toString().toLowerCase() || ''
      if (valA < valB) return sortDirection === 'asc' ? -1 : 1
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1
      return 0
    })
    return sorted
  }

  // ------------------------------------------------------------------------------
  // Búsqueda / Filtros
  // ------------------------------------------------------------------------------
  function applySearch(data: BGP[]) {
    if (!searchTerm) return data
    const lowerTerm = searchTerm.toLowerCase()

    return data.filter((d) => {
      if (searchColumn === 'All') {
        // Buscar en todos los campos relevantes
        return (
          d.nlri?.toLowerCase().includes(lowerTerm) ||
          d.family?.toLowerCase().includes(lowerTerm) ||
          d.neighbor?.toLowerCase().includes(lowerTerm) ||
          d.localpreference?.toLowerCase().includes(lowerTerm) ||
          d.community?.toLowerCase().includes(lowerTerm) ||
          d.extendedcommunity?.toLowerCase().includes(lowerTerm) ||
          d.type?.toLowerCase().includes(lowerTerm)
        )
      } else {
        // Buscar en la columna seleccionada
        const val = d[searchColumn as keyof BGP]?.toString().toLowerCase() || ''
        return val.includes(lowerTerm)
      }
    })
  }

  // ------------------------------------------------------------------------------
  // Paginación + Combinación de Sort & Search
  // ------------------------------------------------------------------------------
  const filteredData = applySearch(DataBGP)
  const sortedData = applySort(filteredData)

  const totalItems = sortedData.length
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedData = sortedData.slice(startIndex, endIndex)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  // ------------------------------------------------------------------------------
  // Manejo de CTX-R y neighbor
  // ------------------------------------------------------------------------------
  const cambiarstate = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setBusqueda(e.target.value)
  }

  const neighseleccionada = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setneighselect(e.target.value)
  }

  const toggleRowExpansion = (index: number) => {
    if (expandedRows.includes(index)) {
      setExpandedRows(expandedRows.filter((rowIndex) => rowIndex !== index))
    } else {
      setExpandedRows([...expandedRows, index])
    }
  }

  // ------------------------------------------------------------------------------
  // Botón Search principal - BGP Summary API Call
  // ------------------------------------------------------------------------------
  const handleSubmit = async (
    e: React.FormEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault()
    if (props.tab === 2 && neighselect !== undefined && direction !== '' && Busqueda !== '') {
      try {
        setLoading(true)

        const body = {
          type: direction,        // BGP direction filter: 'in', 'out', or 'all'
          neighbor: neighselect,  // Specific neighbor IP or empty string for all neighbors
        }

        if (tenant === 0) {
          // Global tenant - no tenant filtering
          const res = await axios.post(`${API_URL}/v1/ctxr/bgpsumary/${Busqueda}`, body)
          setDataBGP(res.data)  // Store the BGP route data
          setCurrentPage(1)     // Reset to first page for new results
        } else {
          // Specific tenant - include tenantId in query parameters
          const res = await axios.post(
            `${API_URL}/v1/ctxr/bgpsumary/${Busqueda}?tenantId=${tenant}`,
            body
          )
          setDataBGP(res.data)  // Store the BGP route data
          setCurrentPage(1)     // Reset to first page for new results
        }

      } catch (error: any) {
        console.log(error)
        // TODO: Add proper error handling and user notification
      } finally {
        setLoading(false)
      }
    }
  }

  const isSearchDisabled = !(Busqueda !== '' && direction !== '' && neighselect !== undefined)

  // ------------------------------------------------------------------------------
  // Carga inicial de CTXR
  // ------------------------------------------------------------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id && Type !== 'CloudGlobal') {
          if (tenant === 0 && currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) {
            const ctxr = await getCTXRlist(Id, Type, nameregion)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          } else if (tenant !== 0 && currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) {
            const ctxr = await getCTXRlistGlobal(Id, tenant, Type, nameregion)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          }
        } else if (Id && Type === 'CloudGlobal') {
          if (tenant === 0 && currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) {
            const ctxr = await getCTXRlist(Id)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          } else if (
            tenant !== 0 &&
            currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')
          ) {
            const ctxr = await getCTXRlistGlobal(Id, tenant)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener CTX-R:', error)
      }
    }

    fetchData()
  }, [Id, Type, nameregion, props.num, tenant, currentUser])

  // ------------------------------------------------------------------------------
  // Cargar lista de neighbors en base a Busqueda (CTX-R) - Neighbor List API Call
  // ------------------------------------------------------------------------------
  useEffect(() => {
    let cancel = false
    const fetchNeighbors = async () => {
      // Early return if no CTX-R available
      if (CTXR.length === 0) {
        setlistneig([])
        setneighselect('')
        setdirection('')
        return
      }
      
      // Check user permissions and ensure CTX-R is selected
      if (currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') && Busqueda !== '') {
        try {
          
          const url =
            tenant === 0
              ? `${API_URL}/v1/ctxr/listneighbor/${Busqueda}`  // Global tenant
              : `${API_URL}/v1/ctxr/listneighbor/${Busqueda}?tenantId=${tenant}`  // Specific tenant
          
          const res = await axios.get(url)
          
          // Only update state if component is still mounted
          if (!cancel) {
            setlistneig(res.data)  // Store neighbor list
            
            // Reset neighbor selection if no neighbors available
            if (res.data.length === 0) {
              setneighselect('')
              setdirection('')
            }
          }
        } catch (error) {
          console.error('Error al obtener neighbors:', error)
        }
      }
    }
    fetchNeighbors()
    
    // Cleanup function to prevent state updates on unmounted component
    return () => {
      cancel = true
    }
  }, [Busqueda, CTXR, tenant, currentUser, Id, Type, nameregion])

  // ------------------------------------------------------------------------------
  // Si no hay CTXR, reseteamos neighbor/direction
  // ------------------------------------------------------------------------------
  useEffect(() => {
    if (CTXR.length === 0) {
      setlistneig([])
      setneighselect('')
      setdirection('')
    }
  }, [CTXR, Id, Busqueda])

  // ------------------------------------------------------------------------------
  // Caso especial: Id === -1
  // ------------------------------------------------------------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) {
          if (tenant === 0) {
            const ctxr = await getCTXRlist(-1)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          } else if (tenant !== 0) {
            const ctxr = await getCTXRlistGlobal(-1, tenant)
            if (ctxr.data && ctxr.data.error === 'id suscription invalido') {
              setctxr([])
            } else {
              setctxr(ctxr.data)
              setBusqueda(ctxr.data[0]?.id || '')
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener CTX-R con Id -1:', error)
      }
    }
    fetchData()
  }, [Id, Type, props.num, currentUser, tenant])

  // ------------------------------------------------------------------------------
  // Limpiar DataBGP cuando cambian Type o tenant
  // ------------------------------------------------------------------------------
  useEffect(() => {
    if (Type || tenant) {
      setDataBGP([])
    }
  }, [Type, tenant])

  // ------------------------------------------------------------------------------
  // Al cambiar Busqueda (CTX-R), limpia neighbor/direction/DataBGP
  // ------------------------------------------------------------------------------
  useEffect(() => {
    if (Busqueda) {
      setneighselect('')
      setdirection('')
      setDataBGP([])
    }
  }, [Busqueda])

  // ------------------------------------------------------------------------------
  // Al cambiar direction, limpiar la tabla
  // ------------------------------------------------------------------------------
  useEffect(() => {
    if (direction) {
      setDataBGP([])
    }
  }, [direction])

  // ------------------------------------------------------------------------------
  // Render principal
  // ------------------------------------------------------------------------------
  return (
    <>
      {loading && <Spinner />}

      <div style={{ marginTop: '15px' }} className="f-titulo fs-md mb-3 text-marino text-center">
        BGP Tables
      </div>

      <div
        className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid"
        id="kt_create_account_stepper"
      >
        {/* Panel izquierdo */}
        <div
          className="card d-flex justify-content-center justify-content-xl-start flex-row-auto w-50 w-xl-200px w-xxl-300px me-9 border border-gray-300"
          style={{ marginBottom: '20px' }}
        >
          <div className="card-body px-6 px-lg-10 py-20">
            <div className="stepper-nav">
              <div className="stepper-item current" data-kt-stepper-element="nav">
                <div className="stepper-wrapper">
                  <div className="stepper-label">
                    <div className="d-flex flex-column align-items-center fw-bold fs-6 mb-4 pe-2">
                      {/* CTX-R */}
                      <div className="d-flex flex-column flex-row-auto mb-3">
                        <label className="form-label f-bold fs-p text-marino required form-label text-center">
                          CTX-R
                        </label>
                        <div className="select-container">
                          <select
                            className="custom-select aligned-select text-center"
                            aria-label="Select example"
                            onChange={cambiarstate}
                            value={Busqueda}
                          >
                            {CTXR.length === 0 && <option disabled hidden>No data</option>}
                            <option disabled hidden>Select an CTX-R</option>
                            {Id !== 0 &&
                              CTXR?.map((ins) => (
                                <option key={ins.id} value={ins.id}>
                                  {ins.name} ({ins.description})
                                </option>
                              ))}
                            {Id === 0 &&
                              Type === 'Global' &&
                              CTXR?.map((ins) => (
                                <option key={ins.id} value={ins.id}>
                                  {ins.name} ({ins.description})
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* Neighbor */}
                      <div className="d-flex flex-column flex-row-auto mb-3">
                        <label className="form-label f-bold fs-p text-marino required form-label text-center">
                          Neighbor
                        </label>
                        <div className="select-container">
                          <select
                            className="custom-select aligned-select text-center"
                            aria-label="Select example"
                            onChange={neighseleccionada}
                            value={neighselect}
                          >
                            {listneighbor?.length === 0 ? (
                              <option key="x" hidden>
                                No Neighbor
                              </option>
                            ) : (
                              <option hidden>Select a Neighbor</option>
                            )}
                            {/* Opción All */}
                            <option value="">All</option>
                            {Busqueda !== '' &&
                              Id !== 0 &&
                              listneighbor.length !== 0 &&
                              listneighbor?.map((ne: nei, i) =>
                                ne.neighbor ? (
                                  <option key={i} value={ne.neighbor}>
                                    {ne.neighbor}
                                  </option>
                                ) : null
                              )}
                            {Busqueda !== '' &&
                              Id === 0 &&
                              Type === 'Global' &&
                              listneighbor.length !== 0 &&
                              listneighbor?.map((ne: nei, i) =>
                                ne.neighbor ? (
                                  <option key={i} value={ne.neighbor}>
                                    {ne.neighbor}
                                  </option>
                                ) : null
                              )}
                          </select>
                        </div>
                      </div>

                      {/* Direction */}
                      <div className="d-flex flex-column flex-row-auto mb-3">
                        <label className="form-label f-bold fs-p text-marino required form-label text-center">
                          Direction
                        </label>
                        <div className="select-container">
                          <select
                            className="custom-select aligned-select text-center"
                            aria-label="Select example"
                            onChange={(e) => setdirection(e.target.value)}
                            value={direction}
                          >
                            <option hidden>Select direction</option>
                            <option key={1} value="in">
                              In
                            </option>
                            <option key={2} value="out">
                              Out
                            </option>
                            <option key={3} value="all">
                              All
                            </option>
                          </select>
                        </div>
                      </div>

                      {/* Search button */}
                      {currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') && (
                        <div className="d-flex flex-column flex-row-auto">
                          <button
                            type="submit"
                            onClick={handleSubmit}
                            className="btn-gradiente"
                            style={{ width: '100px', padding: '6px' }}
                            disabled={isSearchDisabled}
                          >
                            <span className="indicator-label">
                              {loading ? 'Searching...' : 'Search'}
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Panel derecho / Tabla */}
        <div className="d-flex flex-row-fluid bg-body rounded border" style={{ marginBottom: '20px' }}>
          <div className="w-100">
            <div className="card-body pb-10 pb-lg-15">
              {/* Barra de búsqueda si hay datos */}
              {DataBGP.length > 0 && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                    marginRight: '10px',
                  }}
                >
                  <div>
                    <span className="text-marino f-parrafo fw-semibold">
                      Total Records: {totalItems}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                    <div className="input-group custom-search-group" style={{ display: 'flex', height: '30px' }}>
                      <span
                        className="input-group-text"
                        style={{
                          justifyContent: 'center',
                          height: '30px',
                          lineHeight: '30px',
                          padding: '0 8px',
                        }}
                      >
                        <i
                          className="bi bi-search"
                          style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                        ></i>
                      </span>
                      <select
                        className="form-select"
                        style={{
                          border: '1px solid var(--bs-gray-300)',
                          minWidth: '200px',
                          height: '30px',
                          lineHeight: '30px',
                          padding: '0 8px',
                          fontSize: '0.875rem',
                        }}
                        value={searchColumn}
                        onChange={(e) => {
                          setSearchColumn(e.target.value)
                          setCurrentPage(1)
                        }}
                      >
                        <option value="All">All</option>
                        <option value="nlri">Prefix</option>
                        <option value="family">Family</option>
                        <option value="neighbor">Neighbor</option>
                        <option value="localpreference">Local Preference</option>
                        <option value="community">Community</option>
                        <option value="extendedcommunity">Extended Community</option>
                        <option value="type">Direction</option>
                      </select>
                      <input
                        type="text"
                        className="form-control"
                        style={{
                          width: '150px',
                          height: '30px',
                          lineHeight: '30px',
                          padding: '0 8px',
                          fontSize: '0.875rem',
                        }}
                        placeholder={`Search by ${searchColumn === 'All'
                            ? 'All'
                            : searchColumn === 'type'
                              ? 'direction'
                              : searchColumn
                          }`}
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="card-body card-scroll h-450px table-container">
                {DataBGP.length === 0 ? (
                  <div className="no-data-message">No Data Available</div>
                ) : (
                  <table className="w-full f-parrafo caption-bottom custom-table">
                    <thead>
                      <tr className="text-azul text-left">
                        <th
                          className="table-cell"
                          onClick={() => handleSort('nlri')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Prefix</span>
                            <span className={styles['sortable-column']}>{getSortIcon('nlri')}</span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('family')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Family</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('family')}
                            </span>
                          </div>
                        </th>
                        {/* Column neighbor si no se eligió uno en particular */}
                        {neighselect === '' && (
                          <th
                            className="table-cell"
                            onClick={() => handleSort('neighbor')}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className={styles['header-content']}>
                              <span>Neighbor</span>
                              <span className={styles['sortable-column']}>
                                {getSortIcon('neighbor')}
                              </span>
                            </div>
                          </th>
                        )}
                        <th
                          className="table-cell"
                          onClick={() => handleSort('localpreference')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Local Preference</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('localpreference')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('community')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Community</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('community')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('extendedcommunity')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Extended Community</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('extendedcommunity')}
                            </span>
                          </div>
                        </th>
                        {/* Column direction solo si es 'all' o si quieres mostrar siempre */}
                        {direction === 'all' && <th className="table-cell">Direction</th>}
                        <th className="table-cell"></th>
                      </tr>
                    </thead>
                    <tbody style={{ marginTop: '0px' }}>
                      {paginatedData.map((d, i) => (
                        <React.Fragment key={i}>
                          <tr className="table-row">
                            <td className="text-center">{d.nlri}</td>
                            <td className="text-center">{d.family ?? '---'}</td>
                            {neighselect === '' && <td className="text-center">{d.neighbor}</td>}
                            <td className="text-center">{d.localpreference || '---'}</td>
                            <td className="text-center">{d.community || '------'}</td>

                            {/* Extended Community */}
                            {d.extendedcommunity ? (
                              d.extendedcommunity.split(':').length === 3 ? (
                                <td className="text-center">
                                  {d.extendedcommunity.split(':')[1] +
                                    ':' +
                                    d.extendedcommunity.split(':')[2]}
                                </td>
                              ) : d.extendedcommunity.split(':').length === 2 ? (
                                <td className="text-center">{d.extendedcommunity}</td>
                              ) : (
                                <td className="text-center">------</td>
                              )
                            ) : (
                              <td className="text-center">------</td>
                            )}

                            {direction === 'all' && <td className="text-center">{d.type}</td>}

                            {/* Botón de expandir */}
                            <td className="text-dark fw-semibold text-center">
                              <button
                                className="btn btn-primary text-center"
                                style={{ padding: '5px', fontSize: '12px' }}
                                onClick={() =>
                                  toggleRowExpansion(i + (currentPage - 1) * itemsPerPage)
                                }
                              >
                                <i className="bi bi-arrows-angle-expand"></i>
                              </button>
                            </td>
                          </tr>

                          {/* Fila expandida */}
                          {expandedRows.includes(i + (currentPage - 1) * itemsPerPage) && (
                            <tr>
                              <td colSpan={8} className="expanded-details table-cell">
                                <div className="flex-container">
                                  <div className="vertical-table left-table">
                                    <div className="row table-cell">
                                      <div className="column column-title">Prefix:</div>
                                      <div className="column column-value">{d.nlri}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">CTX-R Name:</div>
                                      <div className="column column-value">{d.ctxrName}</div>
                                    </div>
                                    <div className="row  table-cell">
                                      <div className="column column-title">Direction:</div>
                                      <div className="column column-value">{d.type}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Neighbor:</div>
                                      <div className="column column-value">{d.neighbor}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Local IP:</div>
                                      <div className="column column-value">{d.localip}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Local AS:</div>
                                      <div className="column column-value">{d.localas}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Peer AS:</div>
                                      <div className="column column-value">{d.peeras}</div>
                                    </div>
                                  </div>

                                  <div className="vertical-table right-table">
                                    <div className="row table-cell">
                                      <div className="column column-title">Router Id:</div>
                                      <div className="column column-value">{d.routerid}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Family Allowed:</div>
                                      <div className="column column-value">{d.familyallowed}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">RD:</div>
                                      <div className="column column-value">{d.rd}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Origin:</div>
                                      <div className="column column-value">{d.origin}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">AS-Path:</div>
                                      <div className="column column-value">{d.aspath}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Label:</div>
                                      <div className="column column-value">{d.label}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Next Hop:</div>
                                      <div className="column column-value">{d.nexthop}</div>
                                    </div>
                                    <div className="row table-cell">
                                      <div className="column column-title">Subnet:</div>
                                      <div className="column column-value">{d.subnet}</div>
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Route Table - Full Width Section */}
                                <div style={{ 
                                  width: '100%', 
                                  
                                }}>
                                  <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                  }}>
                                    <div style={{ 
                                      width: '120px',
                                      padding: '6px 12px',
                                      textAlign: 'left',
                                      backgroundColor: '#f0f0f0',
                                      fontSize: '0.9em',
                                      borderRadius: '4px 4px 0 0',
                                      borderBottom: 'none'
                                    }}>
                                      Route Table:
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      overflowY: 'auto',
                                      overflowX: 'hidden',
                                      border: '1px solid #ddd',
                                      padding: '12px',
                                      backgroundColor: '#ffffff',
                                      boxSizing: 'border-box',
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      gap: '8px',
                                      alignItems: 'flex-start'
                                    }}
                                  >
                                    {d.route_table
                                        ? d.route_table
                                            .split(/;|\n/)
                                            .map((rt, idx) => rt.trim())
                                            .filter(Boolean)
                                            .map((routeTable, idx) => (
                                              <div
                                                key={idx}
                                                style={{
                                                  display: 'inline-block',
                                                  backgroundColor: '#F0F0F0',
                                                  color: '#333333',
                                                  padding: '6px 12px',
                                                  borderRadius: '16px',
                                                  fontSize: '0.85em',
                                                  fontWeight: '500',
                                                  cursor: 'pointer',
                                                  transition: 'all 0.2s ease',
                                                  fontFamily: 'monospace',
                                                  whiteSpace: 'nowrap',
                                                  maxWidth: '100%',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis'
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor = '#E0E0E0'
                                                  e.currentTarget.style.transform = 'translateY(-1px)'
                                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor = '#F0F0F0'
                                                  e.currentTarget.style.transform = 'translateY(0)'
                                                  e.currentTarget.style.boxShadow = 'none'
                                                }}
                                                title={routeTable}
                                              >
                                                {routeTable}
                                              </div>
                                            ))
                                       : null}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Controles de paginación */}
              {DataBGP.length > 0 && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '10px',
                  }}
                >
                  {/* Espacio vacío a la izquierda para que Next/Previous queden centrados */}
                  <div style={{ visibility: 'hidden' }}></div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className={`btn btn-secondary ${styles.buttonRows}`}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className={`btn btn-secondary ${styles.buttonRows}`}
                    >
                      Next
                    </button>
                  </div>

                  <div className={`${styles.selectContainer}`}>
                    <select
                      className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                      aria-label="Select items per page"
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value))
                        setCurrentPage(1)
                      }}
                    >
                      <option value={5}>5 rows</option>
                      <option value={10}>10 rows</option>
                      {/* Aquí añadimos las nuevas opciones */}
                      <option value={25}>25 rows</option>
                      <option value={50}>50 rows</option>
                      <option value={100}>100 rows</option>
                    </select>
                  </div>
                </div>
              )}

              {/* Caso especial si Id === 0 y Type !== Global */}
              {Id === 0 && Type !== 'Global' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <div className="text-center">Select a Cloud with available subscriptions</div>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
